export default __webpack_public_path__ + "402786b.png";